export default {"src":"/_next/static/media/facebook.ea2bd38f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};